(function() {
  'use strict';

  angular.module('registration', [
    'ngResource',
    'dnErrorDisplay',
    'common',
    'ui.bootstrap'
  ]);
})();